// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._63jlvx0 {\n  height: 40px;\n}\n._63jlvx1 {\n  visibility: hidden;\n}", "",{"version":3,"sources":["webpack://./node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB","sourcesContent":["._63jlvx0 {\n  height: 40px;\n}\n._63jlvx1 {\n  visibility: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
